export const GET_SYNC_DATA = 'GET_SYNC_DATA';

export interface SyncState {
	IsSynching: boolean;
	LastSync: Date; // Used to makes sure that sync is called, is later than 15mins ago.
}
